import { render, staticRenderFns } from "./AccessibleWithFixedStairs.vue?vue&type=template&id=7a7b3c36&"
import script from "./AccessibleWithFixedStairs.vue?vue&type=script&lang=ts&"
export * from "./AccessibleWithFixedStairs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports